'use strict'

class Select {
    constructor(select, hasPlaceholderOption = false) {
        this._wrapper = select.parentNode;
        this._select = select;

        this._hasPlaceholderOption = hasPlaceholderOption;
        if (this._hasPlaceholderOption) {
            this._placeHolderText = this._select.querySelector('option:first-child').innerHTML;
            this._value = null;
        }

        this._isOpen = false;

        this._isDisabled = this._select.closest('.select-custom').classList.contains('select-custom--disabled');

        this._selected = document.createElement("div");
        this._selected.setAttribute("class", "select-selected");
        if (this._select.selectedIndex >= 0) {
            this._selected.innerHTML = this._select.options[this._select.selectedIndex].innerHTML;
        }
        this._wrapper.appendChild(this._selected);

        this._options = document.createElement("DIV");
        this._options.setAttribute("class", "select-items select-hide");

        for (let j = this._select.options.length - 1; j >= 0; j--) {
            if (this._select.options[j].hasAttribute("hidden")) {
                this._select.remove(j);
            }
        }

        for (let j = 0; j < this._select.length; j++) {
            let option = document.createElement("div");
            option.innerHTML = this._select.options[j].innerHTML;

            const optionStyle = this._select.options[j].getAttribute('style');
            if (optionStyle) {
                option.setAttribute('style', optionStyle);
            }

            option.addEventListener("click", (e) => {
                e.stopPropagation();
                this._selectOptionByText(e.currentTarget.innerHTML);
            });
            this._options.appendChild(option);
        }

        this._wrapper.appendChild(this._options);
        this._selected.addEventListener("click", (e) => {
            e.stopPropagation();
            this._closeAllSelect(this._selected);
            setTimeout(() => {
                this._options.classList.toggle("select-hide");
                this._selected.classList.toggle("select-arrow-active");
            }, 0);
            this._select.dispatchEvent(new Event('click'));
        });

        this._timeout = null;
        this._search = '';

        document.addEventListener("click", this._closeAllSelect.bind(this));
        this._select.addEventListener("change", this._onSelectChange.bind(this));
        window.addEventListener("wheel", this._closeAllSelect.bind(this));
        this._wrapper.addEventListener("wheel", (e) => { e.stopPropagation(); });
    }

    _onTimeoutSearch() {
        this._search = '';
    }

    _selectOptionByText(text) {
        for (let i = 0; i < this._select.options.length; i++) {
            if (this._select.options[i].innerHTML == text) {
                this._select.selectedIndex = i;
                this._selected.innerHTML = text;
            }
        }

        const options = Array.from(this._options.children);
        for (let i = 0; i < options.length; i++) {
            options[i].classList.toggle("selected", this._select.selectedIndex === i);
        }

        this._select.dispatchEvent(new Event('change'));
        this._selected.click();
    }

    _closeAllSelect(elmnt) {
        const x = document.getElementsByClassName("select-items");
        const y = document.getElementsByClassName("select-selected");
        const arrNo = [];

        for (let i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i)
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }

        for (let i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }

    addEventListener(event, callback) {
        this._select.addEventListener(event, callback);
    }

    hasSelection() {
        return this._select.selectedIndex != 0;
    }

    setError(error) {
        if (error) {
            this._wrapper.closest('.form-group').classList.add('error');
        } else {
            this._wrapper.closest('.form-group').classList.remove('error');
        }
    }

    _onSelectChange(e) {
        this._value = this._select.value;

        if (this._wrapper.closest('.form-group')) {
            if (this._select.selectedIndex == 0 && this._hasPlaceholderOption) {
                this._wrapper.closest('.form-group').classList.remove('form-group--filled');
            } else {
                this._wrapper.closest('.form-group').classList.add('form-group--filled');
            }
        }
    }

    reset() {
        this._select.selectedIndex = 0;

        if (this._hasPlaceholderOption && this._placeHolderText) {
            this._selected.innerHTML = this._placeHolderText;
        } else {
            this._selected.innerHTML = '';
        }

        let optionSelected = this._wrapper.querySelector('.select-items .selected');
        if (optionSelected) {
            optionSelected.classList.remove('selected');
        }

        this._wrapper.closest('.form-group').classList.remove('form-group--filled');
        this.setError(false);
    }

    refresh() {
        this._select.value = '';
        this._options.innerHTML = '';

        if (this._hasPlaceholderOption && this._placeHolderText) {
            this._selected.innerHTML = this._placeHolderText;
        } else {
            this._selected.innerHTML = '';
        }

        this._wrapper.closest('.form-group').classList.remove('form-group--filled');

        for (let j = this._select.options.length - 1; j >= 0; j--) {
            if (this._select.options[j].hasAttribute("hidden")) {
                this._select.remove(j);
            }
        }

        for (let j = 0; j < this._select.length; j++) {
            let option = document.createElement("div");
            option.innerHTML = this._select.options[j].innerHTML;
            option.addEventListener("click", (e) => {
                e.stopPropagation();
                this._selectOptionByText(e.currentTarget.innerHTML);
            });
            this._options.appendChild(option);
        }
    }

    empty() {
        this._select.innerHTML = '';
        this.refresh();
    }

    set items(items) {
        this._select.innerHTML = '';

        items.forEach((item) => {
            this._select.insertAdjacentHTML('beforeend',
                `<option value="${item.value}">${item.text}</option>`);
        });

        this.refresh();
    }

    get value() {
        return this._value;
    }

    set value(value) {
        this._select.value = value;
        this._value = value;

        const selectedIndex = this._select.selectedIndex;
        if (selectedIndex < 0 || !this._select.options[selectedIndex]) {
            this._selected.innerHTML = this._placeHolderText || '';
            return;
        }

        this._selected.innerHTML = this._select.options[selectedIndex].text;

        const options = Array.from(this._options.children);
        for (let i = 0; i < options.length; i++) {
            options[i].classList.toggle("selected", i === selectedIndex);
        }
    }

    get select() {
        return this._select;
    }

    set disabled(disabled) {
        if (disabled) {
            this._select.closest('.select-custom').classList.add('select-custom--disabled');
        } else {
            this._select.closest('.select-custom').classList.remove('select-custom--disabled');
        }

        this._isDisabled = disabled;
    }

    get disabled() {
        return this._isDisabled;
    }
}

export default Select;
